import pixel from "@frog/source/views/app/stage/pixel.js"
import Keyset from "@frog/source/utility/Keyset.js"

export default function Particles(stage) {
    const views = []
    if(stage.particles != undefined) {
        Keyset.forEach(stage.particles, (particle, particleKey) => {
            // try {
            views.push({
                "key": "particle/" + particleKey,
                "position": pixel("particle", particle.position ? {
                    "x": particle.position.x,
                    "y": particle.position.y,
                    "z": particle.position.z,
                } : {}),
                "scale": {
                    "x": particle.scale || 1,
                    "y": particle.scale || 1,
                },
                "image": particle.image,
                "rotation": particle.rotation,
            })
            // } catch(error) {console.log(particle, particle.position, error)}
        })
    }
    return views
}
